import { useTheme } from "@rentiohq/web-shared-next/dist/themes";

export const ProductDetailStyles = () => {
  const theme = useTheme();

  return {
    content: {
      avatar: {
        bgcolor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.grey[500]}`,
        svg: {
          width: "38.4px",
          height: "38.4px",
          color: theme.palette.grey[500],
        },
      },
      profileImg: {
        bgcolor: theme.palette.background.paper,
        img: {
          objectFit: "cover",
        },
      },
    },
  };
};
